module.exports = __webpack_public_path__ + "static/media/diktat-34.76943ca9.mp3";